export const ProductListFilters = () => {
  const filterToggle = document.querySelector(".toggle-filter");
  const filterPanel = document.querySelector(
    ".woocommerce-product-list-filters"
  );
  const filterClose = document.querySelector(".close-filters");

  if (!filterPanel) return;

  if (filterToggle) {
    filterToggle.addEventListener("click", () => {
      filterPanel.classList.add("isOpen");
      document.body.classList.add("no-scroll");
    });
  }

  if (filterClose) {
    filterClose.addEventListener("click", () => {
      filterPanel.classList.remove("isOpen");
      document.body.classList.remove("no-scroll");
    });
  }
};
